export default [
  {
    path: '/patterns',
    name: 'patterns',
    component: () => import('@/views/patterns/PatternsOverview.vue'),
    meta: {
      pageTitle: 'Patterns',
      breadcrumb: [
        {
          text: 'Patterns',
          active: true,
        },
      ],
    },
  },
]
